<template>
  <div class="skeleton-animate" />
</template>
<script>
export default {
  name: "SkeletonAnimate",
};
</script>
<style lang="scss" scoped>
.skeleton-animate {
  width: 100%;
  will-change: transform;
  animation: placeHolderShimmer 3s linear infinite forwards;
  -webkit-backface-visibility: hidden;
  background: #e6e6e6;
  background: linear-gradient(90deg, #eee 8%, #ddd 18%, #eee 33%);
  background-size: 800px 104px;
  height: 100%;
  position: relative;
}
@keyframes placeHolderShimmer {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-position: -468px 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-position: 468px 0;
  }
}
</style>